import { render } from "./InformationProtection.vue?vue&type=template&id=2b04f7f3&scoped=true"
import script from "./InformationProtection.vue?vue&type=script&lang=js"
export * from "./InformationProtection.vue?vue&type=script&lang=js"

import "./InformationProtection.vue?vue&type=style&index=0&id=2b04f7f3&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b04f7f3"]])

export default __exports__